'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (type) {
    switch (type) {
        case 'STRING':
        case 'TEXT':
            return function (item) {
                return '' + item;
            };
        case 'INTEGER':
        case 'NUMBER':
            return function (item) {
                return (0, _isNumeric2.default)(item) ? parseFloat(item) : item;
            };
        default:
            return function (item) {
                return item;
            };
    }
};

var _isNumeric = require('d2-utilizr/lib/isNumeric');

var _isNumeric2 = _interopRequireDefault(_isNumeric);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;
//# sourceMappingURL=getParseMiddleware.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/util/getParseMiddleware.js
 ** module id = 175
 ** module chunks = 0 1
 **/